<app-aggregated-amount-item
  name="UM ストアページビュー"
  icon="./assets/universal_music.png"
  amount="{{ (umstorePageview$ | async)?.units }}"
  unit="ページビュー数"
  [rate]="(umstorePageview$ | async)?.rate"
  [link]="(selectedArtist$ | async)?.umstoreUrl"
  [hasAmount]="(umstorePageview$ | async)?.hasUnits"
  help="{{
    (selectedArtist$ | async)?.nameMain
  }} のD2Cストアのページビュー数です。ページビュー数は選択期間内の合計数です。"
  [loading]="loading$ | async"
  [dataCollections]="dataCollections$ | async"
  [dataCollectLoading]="dataCollectLoading$ | async"
></app-aggregated-amount-item>
